<template>
  <div :class="{
    'image-story-container' : !$isIsef,
    'image-story-container-isef' : $isIsef
  }" >
    <awards v-if="!$isIsef" :projectAwards="projectAwards"/>
    <isef-awards v-else :projectAwards="projectAwards"/>
    <div class="image story"
         :class="{loading: image.loading || (isBlank && isVisible) || isRowLoading,
         loaded: !isRowLoading && image.loaded || image.error,
         'overlay-exist-ysc': $isYSC, 'image-isef' : $isIsef}"
         :style="imageBackground"
    />
  </div>
</template>

<script>
import Awards from '../UI/Awards'
import IsefAwards from '../UI/Isef/Awards'
export default {
  components: {
    Awards,
    IsefAwards
  },
  props: ['image', 'isRowLoading', 'imageBackground', 'imageOverlay', 'isBlank', 'isVisible', 'project', 'projectAwards'],
  computed: {
    isStemExpo: function () {
      return this.$route.fullPath.includes('/stem-expo')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .image-story-container{
    width: 100%;
    height: 100%;
    position: relative;
    &-isef {
      width: 100%;
      height: 175px !important;
      position: relative;
    }
  }
  .image {
    // condition this height on if there is a footer or not
    height: 100%;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    z-index: 3;
    &-isef {
      border-top-right-radius: .6rem !important;
      border-top-left-radius: .6rem !important;
    }

    &.loading {
      animation: loading 1s linear infinite;
      background-image: linear-gradient(to right, #F8F8F8 0%, white 20%, #F8F8F8 40%, #F8F8F8 100%);
      background-size: 250% 250%;

      @keyframes loading {
        0% { background-position: -100% 0; }
        100% { background-position: 100% 0; }
      }
    }
    &.loaded {
      background-size: 100% 100%;
      background-position: center;
    }
    &.overlay-exist {
      background-size: contain;
      background-position: center;
      &-ysc {
       background-size: cover !important;
      }
    }
  }
  .background-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-size: 80rem;
  }
  .background-overlay-blur {
    filter: blur(0.5rem);
  }
</style>
